<template>

  <tr>
    <td class="text-truncate">{{ entity }}</td>
    <td class="text-truncate">{{ stauts }}</td>
    <td class="text-truncate">{{ size }}</td>
    <td class="text-truncate">{{ author }}</td>
    <td class="text-truncate">{{ $d(new Date(value.created_at), 'short') }}</td>
    <td style="width: 160px">
      <a
        v-if="isCompleted"
        class="btn btn-block btn-sm btn-outline-primary"
        :href="value.url">
        <i class="fas fa-download" /> {{ $t('Download') }}
      </a>
      <button
        v-if="!isCompleted"
        type="button"
        class="btn btn-block btn-sm btn-outline-secondary"
        disabled>
        Processando...
      </button>
    </td>
  </tr>

</template>

<script>
import prettyBytes from 'pretty-bytes'

export default {
  name: 'Dataimex',
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: {
  },
  data () {
    return {
      interval: false
    }
  },
  computed: {
    isCompleted () {
      return this.value.status === 'complete' && this.value.url
    },
    stauts () {
      return {
        complete: 'Concluído',
        pending: 'Pendente'
      }[this.value.status]
    },
    type () {
      return {
        import: 'Importado',
        export: 'Exportado'
      }[this.value.type]
    },
    entity () {
      return {
        'candidate': this.$t('Candidate'),
        'job-candidate': this.$t('Candidate in the job'),
        'report': this.$t('Report'),
        'candidate-hired': this.$t('Hired candidate'),
        'job-detail': this.$t('Job details'),
        'job-pipeline': this.$t('Job pipeline')
      }[this.value.entity]
    },
    author () {
      return this.value.author_user_id ? this.value.author_user_id.name : null
    },
    size () {
      const bytes = this.value.content_length || 0
      return prettyBytes(bytes)
    }
  },
  watch: {
    'value.status' (val) {
      if (val === 'pending') {
        clearInterval(this.interval)
        this.loadInterval()
      }
    }
  },
  destroyed () {
    clearInterval(this.interval)
  },
  methods: {
    loadInterval () {
      this.interval = setTimeout(() => {
        this.$store.dispatch('getDataimexById', this.value._id).then(result => {
          if (result.status === 'pending') {
            this.loadInterval()
          }
        })
      }, 5000)
    },
    remove () {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteDataimex', this.value._id)
        .then((result) => {
          this.loading = false
          this.$emit('removed')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dataimex/DataimexItem.vue